import React from 'react';
import Layout from '../components/Layout';
import ChangePasswordCard from '../components/ChangePasswordCard';

function ChangePassword() {

  return (
    <Layout videoUrl="https://burakgundogan.net/videos/15869190_1080_1920_30fps.mp4">
      <ChangePasswordCard />
    </Layout>
  );
}

export default ChangePassword;